<div class="jumbotron jumbotron-fluid d-none d-md-flex flex-column justify-content-center align-items-center mb-0" id="hero-jumbotron">
  <span #slotContent class="w-100">
    <ng-content></ng-content>
  </span>
  <img *ngIf="!slotContent.innerHTML.trim()" [src]="image_link" alt="Category name" />
  <div class="jumbotron-container container-xl d-flex flex-column align-items-center">
    <h1 [hidden]="title_is_home_title" id="jumbotron-title" class="mb-5 playball-regular text-center" style="font-size: 4rem;">{{ title }}</h1>
    <img [hidden]="!title_is_home_title" [src]="app_logo" class="hero-logo" alt="Bonnie Logo">
    <h4 *ngIf="checkOnHomePage()" class="text-center mb-3 playball-regular h3 text-white">{{ tagline }}</h4>
    <form class="justify-content-center px-5 py-4 mt-5 bg-light w-75 rounded-lg shadow" action="#">
      <div class="row">
        <div class="col-12 mb-4 px-0">
          <div class="left-icon w-100">
            <span class="fas fa-search"></span>
            <input class="form-control" name="service" type="text" [(ngModel)]="search_query" (keydown.enter)="submitForm()" placeholder="Service you are searching for..." />
          </div>
        </div>
        <!-- <div class="col-12 col-md-6 mb-4">
          <div class="left-icon">
            <span class="far fa-calendar-alt"></span>
            <input class="form-control" name="date" type="text" [(ngModel)]="date_input" placeholder="Pick a date">
          </div>
        </div>
        <div class="col-12 col-md-6 mb-4">
          <div class="left-icon">
            <span class="far fa-clock"></span>
            <input class="form-control" name="time" type="text" [(ngModel)]="time_input" placeholder="Pick a time">
          </div>
        </div> -->
        <div class="col-12 mb-4 px-0" *ngIf="on_bonnie === true">
          <div class="left-icon w-100">
            <span class="fas fa-location-arrow"></span>
            <input class="form-control" name="date" type="text" popupClass="typeahead-popup-container" [showHint]="true" [(ngModel)]="search_location" placeholder="Search by postcode" autocomplete="off" [ngbTypeahead]="search">
            <!-- <input class="form-control" name="date" type="text" appClickPreventDefault (click)="showDropdown()" (focus)="showDropdown()" (keydown)="showDropdown()" (keydown.enter)="submitForm()" [(ngModel)]="search_location" placeholder="Search by postcode" autocomplete="new-password"> -->
            <!-- <ul #dropdown [class.show]="dropdownShow === true" class="dropdown-menu w-100" (clickOutside)="closeDropdown()">
              <ng-template *ngIf="postcodes_total === 0">
                <p class="text-center"><i class="fas fa-spinner fa-spin fs-2x"></i></p>
              </ng-template>
              <ng-template *ngIf="postcodes_total > 0">
                <li class="dropdown-item" *ngFor="let postcode of postcodes" (click)="setLocation(postcode)">{{ postcode }}</li>
              </ng-template>
            </ul> -->
          </div>
        </div>
        <div class="col-12 px-0">
          <button #submitBtn [class.disabled]="search_query !== '' || search_location !== ''" [routerLink]="submit_link" [replaceUrl]="true" type="button" class="btn btn-block btn-dark lemon-milk-light">
            <!-- <button [class.disabled]="search_query !== ''" [routerLink]="'/search/' + search_query"  [queryParams]="{date: date_url, time: time_url}" type="button" class="btn btn-block btn-dark lemon-milk-light"> -->
            <i class="fas fa-search"></i> Search
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<app-hero-nav [show_active]="nav_show_active"></app-hero-nav>